export const SECTION_BEST_PICKS = 'bestpicks'
export const SECTION_BUYING_GUIDE = 'buying-guide'
export const SECTION_CONTAINER = 'container'
export const SECTION_MORECOVERAGE = 'morecoverage'
export const SECTION_OURAPPROACH = 'ourapproach'
export const SECTION_REVIEWS = 'reviews'
export const SECTION_SERVICES = 'services'
export const SECTION_WIDGET = 'widget'
